import React, { memo } from "react";
import { SvgIcon } from "@mui/material";
import { IIconProps } from "@/models";

const ThreeDotIcon = ({ sx, ...otherProps }: IIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 25 25"
      sx={{ fontSize: "inherit", ...sx }}
      {...otherProps}
    >
      <path
        d="M4.63583 14.8437C3.06935 14.8437 1.79492 13.6255 1.79492 12.1294C1.79492 10.6327 3.06935 9.41504 4.63583 9.41504C6.20231 9.41504 7.47674 10.6327 7.47674 12.1294C7.47674 13.6249 6.20231 14.8437 4.63583 14.8437ZM4.63583 10.5002C3.69606 10.5002 2.93129 11.2309 2.93129 12.1288C2.93129 13.0267 3.69606 13.7574 4.63583 13.7574C5.57561 13.7574 6.34038 13.0267 6.34038 12.1288C6.34038 11.2309 5.57561 10.5002 4.63583 10.5002Z"
        fill="currentColor"
      />
      <path
        d="M12.6251 14.8437C11.0592 14.8437 9.78418 13.6255 9.78418 12.1294C9.78418 10.6327 11.0592 9.41504 12.6251 9.41504C14.1921 9.41504 15.466 10.6327 15.466 12.1294C15.466 13.6249 14.1921 14.8437 12.6251 14.8437ZM12.6251 10.5002C11.6853 10.5002 10.9205 11.2309 10.9205 12.1288C10.9205 13.0267 11.6853 13.7574 12.6251 13.7574C13.5649 13.7574 14.3296 13.0267 14.3296 12.1288C14.3296 11.2309 13.5649 10.5002 12.6251 10.5002Z"
        fill="currentColor"
      />
      <path
        d="M20.3643 14.8437C18.7984 14.8437 17.5234 13.6255 17.5234 12.1294C17.5234 10.6327 18.7984 9.41504 20.3643 9.41504C21.9314 9.41504 23.2052 10.6327 23.2052 12.1294C23.2052 13.6249 21.9314 14.8437 20.3643 14.8437ZM20.3643 10.5002C19.4246 10.5002 18.6598 11.2309 18.6598 12.1288C18.6598 13.0267 19.4246 13.7574 20.3643 13.7574C21.3041 13.7574 22.0689 13.0267 22.0689 12.1288C22.0689 11.2309 21.3041 10.5002 20.3643 10.5002Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default memo(ThreeDotIcon);
